import { render, staticRenderFns } from "./microblog.vue?vue&type=template&id=99a8e328&"
import script from "./microblog.vue?vue&type=script&lang=ts&"
export * from "./microblog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('99a8e328')) {
      api.createRecord('99a8e328', component.options)
    } else {
      api.reload('99a8e328', component.options)
    }
    module.hot.accept("./microblog.vue?vue&type=template&id=99a8e328&", function () {
      api.rerender('99a8e328', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/microblog/microblog.vue"
export default component.exports